import { render, staticRenderFns } from "./CandidateAiAssessments.vue?vue&type=template&id=20e6e193&scoped=true"
import script from "./CandidateAiAssessments.vue?vue&type=script&lang=ts"
export * from "./CandidateAiAssessments.vue?vue&type=script&lang=ts"
import style0 from "./CandidateAiAssessments.vue?vue&type=style&index=0&id=20e6e193&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6e193",
  null
  
)

export default component.exports